export const APPLICATIONS = [
  { name: 'efactura Web', sku: 'PW001', price: 0, description: 'Nuestra aplicación web de facturación electrónica, fácil de usar, disponible en cualquier plan' },
  {
    name: 'QuickBooks',
    sku: 'INT011',
    description: 'Integracion gratuita en planes de 1,200 facturas en adelante.',
    price: 0,
  },
  {
    name: 'Sage50/Peachtree',
    sku: 'INT002',
    description: 'Soporte/mantenimiento anual de $50 desde el segundo ano.',
    price: 200,
  },
  {
    name: 'Zoho Books',
    sku: 'INT012',
    description: 'Integracion gratuita en planes de 1,200 facturas en adelante.',
    price: 0,
  },
  { name: 'Loyverse', sku: 'INT010', price: 100, description: 'Integración de Loyverse, con opción de impresión térmica en Android y Windows' },
  { name: 'Shopify', sku: 'INT004', price: 200, description: 'Soporte anual de $50 desde el segundo año. Opción de impresión térmica en Android y Windows' },
  { name: 'WooCommerce', sku: 'INT003', price: 200, description: 'Soporte anual de $50 desde el segundo año.' },
  { name: 'Xero ERP', sku: 'INT006', price: 200, description: 'Soporte anual de $50 desde el segundo año.' },
  { name: 'Odoo ERP', sku: 'INT005', price: 200, description: 'Soporte anual de $50 desde el segundo año.' },
  { name: 'API', sku: 'INT013', price: 0, description: 'ceso a API de integración. Desarrollo por cuenta propia o un tercero.' },
];

export const PLANS = [
  {
    id: 'FE120',
    folios: 120,
    friendlyName: '1 a 10 facturas mensuales',
    standardName: 'Hasta 120 facturas anuales',
    price: 30,
  },
  {
    id: 'FE600',
    folios: 600,
    friendlyName: '11 a 50 facturas mensuales',
    standardName: 'Hasta 600 facturas anuales',
    price: 40,
  },
  {
    id: 'FE1200',
    folios: 1200,
    friendlyName: 'Alrededor de 100 facturas mensuales',
    standardName: 'Hasta 1200 facturas anuales',
    price: 60,
  },
  {
    id: 'FE2400',
    folios: 2400,
    friendlyName: '2,400 facturas',
    standardName: 'Plan anual',
    price: 119,
  },
  {
    id: 'FE3600',
    folios: 3600,
    friendlyName: '3,600 facturas',
    standardName: 'Plan anual',
    price: 156,
  },
  {
    id: 'FE4800',
    folios: 4800,
    friendlyName: '4,800 facturas',
    standardName: 'Plan anual',
    price: 192,
  },
  {
    id: 'FE6000',
    folios: 6000,
    friendlyName: '6,000 facturas',
    standardName: 'Plan anual',
    price: 220,
  },
  {
    id: 'FE9000',
    folios: 9000,
    friendlyName: '9,000 facturas',
    standardName: 'Plan anual',
    price: 225,
  },
  {
    id: 'FE12K',
    folios: 12000,
    friendlyName: '12,000 facturas',
    standardName: 'Sin expiración anual.',
    price: 240,
  },
];

const RESTRICTED_APP_NAMES = new Set(['QuickBooks', 'Zoho Books']);

export const isRestrictedApp = (appName) => RESTRICTED_APP_NAMES.has(appName);

export const getAllowedPlansForApp = (application) => {
  if (!application || !isRestrictedApp(application.name)) {
    return PLANS;
  }

  return PLANS.filter((plan) => plan.folios >= 1200);
};

export const getApplicationBySku = (sku) => {
  if (!sku) {
    return null;
  }

  const normalizedSku = String(sku).trim().toUpperCase();
  return APPLICATIONS.find((app) => app.sku.toUpperCase() === normalizedSku) || null;
};

export const getPlanBySku = (sku) => {
  if (!sku) {
    return null;
  }

  const normalizedSku = String(sku).trim().toUpperCase();
  return PLANS.find((plan) => plan.id.toUpperCase() === normalizedSku) || null;
};

export const formatCurrency = (value) => {
  if (typeof value !== 'number') {
    return 'Valor a confirmar';
  }

  return new Intl.NumberFormat('es-PA', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value) + (value > 0 ?" + ITBMS":"");
};
